/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { EmailHandle } from "./EmailHandle";
import {
  EmailHandleFromJSON,
  EmailHandleFromJSONTyped,
  EmailHandleToJSON,
  EmailHandleToJSONTyped,
} from "./EmailHandle";

/**
 *
 * @export
 * @interface OutlookMessageSummary
 */
export interface OutlookMessageSummary {
  /**
   *
   * @type {string}
   * @memberof OutlookMessageSummary
   */
  messageId: string;
  /**
   *
   * @type {string}
   * @memberof OutlookMessageSummary
   */
  conversationId?: string | null;
  /**
   *
   * @type {string}
   * @memberof OutlookMessageSummary
   */
  subject?: string | null;
  /**
   *
   * @type {EmailHandle}
   * @memberof OutlookMessageSummary
   */
  from?: EmailHandle | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof OutlookMessageSummary
   */
  receivedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof OutlookMessageSummary
   */
  preview?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof OutlookMessageSummary
   */
  hasAttachments: boolean;
}

/**
 * Check if a given object implements the OutlookMessageSummary interface.
 */
export function instanceOfOutlookMessageSummary(
  value: object,
): value is OutlookMessageSummary {
  if (!("messageId" in value) || value["messageId"] === undefined) return false;
  if (!("hasAttachments" in value) || value["hasAttachments"] === undefined)
    return false;
  return true;
}

export function OutlookMessageSummaryFromJSON(
  json: any,
): OutlookMessageSummary {
  return OutlookMessageSummaryFromJSONTyped(json, false);
}

export function OutlookMessageSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OutlookMessageSummary {
  if (json == null) {
    return json;
  }
  return {
    messageId: json["messageId"],
    conversationId:
      json["conversationId"] == null ? undefined : json["conversationId"],
    subject: json["subject"] == null ? undefined : json["subject"],
    from: json["from"] == null ? undefined : EmailHandleFromJSON(json["from"]),
    receivedAt: json["receivedAt"] == null ? undefined : json["receivedAt"],
    preview: json["preview"] == null ? undefined : json["preview"],
    hasAttachments: json["hasAttachments"],
  };
}

export function OutlookMessageSummaryToJSON(json: any): OutlookMessageSummary {
  return OutlookMessageSummaryToJSONTyped(json, false);
}

export function OutlookMessageSummaryToJSONTyped(
  value?: OutlookMessageSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    messageId: value["messageId"],
    conversationId: value["conversationId"],
    subject: value["subject"],
    from: EmailHandleToJSON(value["from"]),
    receivedAt: value["receivedAt"],
    preview: value["preview"],
    hasAttachments: value["hasAttachments"],
  };
}
